import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";

export const fetchFailureAnalysisRequest = createAsyncThunk(
  "fetchFailureAnalysisRequest",
  async ({ data, callBack }) => {
    const { page, limit, sort_by, order_by, from_date, to_date, company_id } = data;

    // Build query parameters conditionally
    const queryParams = new URLSearchParams({
      page: page,
      limit: limit,
      sort_by: sort_by,
      order_by: order_by,
    });

    if (from_date) queryParams.append("from_date", from_date);
    if (to_date) queryParams.append("to_date", to_date);
    if (company_id) queryParams.append("company_id", company_id);

    const response = await APIKit().get(
      `${API_END_POINTS.getAllfailureAnalysisRequest}?${queryParams.toString()}`
    );

    if (response?.status === 200 || 400) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.getAllfailureAnalysisRequest
        } ====> ${JSON.stringify(response?.message)}`
      );
    }
    return response?.data;
  }
);

export const fetchSingleFailureAnalysisRequest = createAsyncThunk(
  "fetchSingleFailureAnalysisRequest",
  async ({ data, callBack }) => {
    const response = await APIKit().get(
      `${API_END_POINTS.getIndividualfailureAnalysisRequest}/${data?.remote_failure_details_id}`
    );

    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.getIndividualfailureAnalysisRequest
        } ====> ${JSON.stringify(response?.message)}`
      );
    }
    return response?.data;
  }
);

export const fetchAllModeOfFailure = createAsyncThunk(
  "fetchAllModeOfFailure",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(`${API_END_POINTS.getModeOfFailure}`);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.getModeOfFailure} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);

export const fetchAllBearingComponent = createAsyncThunk(
  "fetchAllBearingComponent",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(`${API_END_POINTS.getBearingComponent}`);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.getBearingComponent} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);

export const downloadFARReport = createAsyncThunk(
  "downloadFARReport",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.downloadFarReport}/${data?.remote_failure_details_id}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.downloadFarReport} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
  }
)

export const getFarReport = createAsyncThunk(
  "getFarReport",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getFarPdfReport}/${data?.remote_failure_details_id}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.getFarPdfReport} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
  }
)

export const fetchBearingType = createAsyncThunk(
  "fetchBearingType",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(`${API_END_POINTS.bearingType}`);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.bearingType} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);

export const fetchLubricationType = createAsyncThunk(
  "fetchLubricationType",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(`${API_END_POINTS.lubricationType}`);
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.lubricationType} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);

export const addInvestigation = createAsyncThunk(
  "addInvestigation",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addInvestigation}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.addInvestigation} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const fetchIndividualInvestigation = createAsyncThunk(
  "fetchIndividualInvestigation",
  async ({ data, callBack }) => {
    const response = await APIKit().get(
      `${API_END_POINTS.fetchInvestigation}/${data?.remote_failure_details_id}`
    );

    if (response?.status === 200 || 400) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.fetchInvestigation
        } ====> ${JSON.stringify(response?.message)}`
      );
    }
    return response?.data;
  }
);

export const addAssetDetails = createAsyncThunk(
  "addAssetDetails",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addAssetDetails}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.addAssetDetails} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const addSecondaryDetail = createAsyncThunk(
  "addSecondaryDetail",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addSecondaryDetail}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.addSecondaryDetail} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);


export const fetchAssetDetails = createAsyncThunk(
  "fetchAssetDetails",
  async ({ data, callBack }) => {
    const response = await APIKit().get(
      `${API_END_POINTS.fetchAssetDetails}/${data?.remote_failure_details_id}`
    );

    if (response?.status === 200 || 400) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.fetchAssetDetails
        } ====> ${JSON.stringify(response?.message)}`
      );
    }
    return response?.data;
  }
);

export const fetchSecondaryDetail = createAsyncThunk(
  "fetchSecondaryDetail",
  async ({ data, callBack }) => {
    const response = await APIKit().get(
      `${API_END_POINTS.fetchSecondaryDetail}/${data?.remote_failure_details_id}`
    );

    if (response?.status === 200 || 400) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.fetchSecondaryDetail
        } ====> ${JSON.stringify(response?.message)}`
      );
    }
    return response?.data;
  }
);

export const addBearingDetails = createAsyncThunk(
  "addBearingDetails",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addBearingDetails}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.addBearingDetails} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const fetchBearingDetails = createAsyncThunk(
  "fetchBearingDetails",
  async ({ data, callBack }) => {
    const response = await APIKit().get(
      `${API_END_POINTS.fetchAnalysis}/${data?.remote_failure_details_id}`
    );

    if (response?.status === 200 || 400) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.fetchAnalysis
        } ====> ${JSON.stringify(response?.message)}`
      );
    }
    return response?.data;
  }
);

export const addRecommendation = createAsyncThunk(
  "addRecommendation",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addRecommendation}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.addRecommendation} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const fetchRecommendation = createAsyncThunk(
  "fetchRecommendation",
  async ({ data, callBack }) => {
    const response = await APIKit().get(
      `${API_END_POINTS.fetchRecommendations}/${data?.remote_failure_details_id}`
    );

    if (response?.status === 200 || 400) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.fetchRecommendations
        } ====> ${JSON.stringify(response?.message)}`
      );
    }
    return response?.data;
  }
);

// getPrimaryModeOfFailure
export const getPrimaryModeOfFailure = createAsyncThunk("getPrimaryModeOfFailure", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.getPrimaryModeOfFailure}`, data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.getPrimaryModeOfFailure} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const getSecondaryDetail = createAsyncThunk("getSecondaryDetail", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.getSecondayDetail}`, data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.getSecondayDetail} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const editInvestigation = createAsyncThunk(
  "editInvestigation",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.editInvestigation}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.editInvestigation} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);
export const editAssetDetails = createAsyncThunk(
  "editAssetDetails",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.editAssetDetails}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.editAssetDetails} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const editSecondayDetail = createAsyncThunk(
  "editSecondayDetail",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.editSecondayDetail}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.editSecondayDetail} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const editBearingDetails = createAsyncThunk(
  "editBearingDetails",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.editBearingDetails}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.editBearingDetails} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);
export const editRecommendation = createAsyncThunk(
  "editRecommendation",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.editRecommendation}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
      // alert(JSON.stringify(response));
      console.log(
        `Error ===> ${API_END_POINTS.editRecommendation} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const fetchPreviewData = createAsyncThunk(
  "fetchPreviewData",
  async ({ data, callBack }) => {
    const response = await APIKit().get(
      `${API_END_POINTS.previewReportData}/${data?.remote_failure_details_id}`
    );

    if (response?.status === 200 || 400) {
      callBack(response?.data || {});
    } else {
      notifyError(response?.data?.message);
      console.log(
        `Error ===> ${API_END_POINTS.previewReportData} ====> ${JSON.stringify(
          response?.message
        )}`
      );
    }
    return response?.data;
  }
);

export const sendReport = createAsyncThunk(
  "sendReport",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.sendReport}/${data?.id}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);

      console.log(
        `Error ===> ${API_END_POINTS.sendReport} ====> ${JSON.stringify(
          response
        )}`
      );
    }
    return response?.data;
  }
);

export const failureAnalysisReqSlice = createSlice({
  name: "failureAnalysisRequest",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFailureAnalysisRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchFailureAnalysisRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchFailureAnalysisRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });
  },
});

export default failureAnalysisReqSlice.reducer;
